
import { Options, Vue } from 'vue-class-component';
import { fgcService } from '@/services/fgc.service';
import { Subscription } from 'rxjs';

@Options({})
export default class FGCObsView extends Vue {
  currentTotal = 250;

  private eventSub: Subscription | null = null;

  async mounted() {
    this.eventSub = fgcService.getEvent().subscribe(event => {
      if (event) {
        this.currentTotal = parseFloat(event.current_total as any);
      }
    });

    await fgcService.fetchEvent();
  }

  unmounted() {
    this.eventSub?.unsubscribe();
  }
}
